import React from "react";
import { FiMessageCircle } from "react-icons/fi";
import type { Clarification } from "../../types/clarification.type";
import Tooltip from "components/Tooltip";

interface ClarificationChatButtonProps {
  clarification: Clarification;
  unreadCount?: number;
  onOpenChat: (clarification: Clarification) => void;
}

export const ClarificationChatButton: React.FC<ClarificationChatButtonProps> = ({
  clarification,
  onOpenChat,
  unreadCount = 0,
}) => {
  if (!clarification.is_sent) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpenChat(clarification);
  };

  return (
    <Tooltip label="Chat about this clarification" shouldWrapChildren>
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-1.5 rounded-md text-sm text-blue-600 hover:bg-blue-50 hover:text-blue-800"
        aria-label="Chat about this clarification"
      >
        <FiMessageCircle className="h-4 w-4" />
        {unreadCount > 0 && (
          <span className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-semibold text-white">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
    </Tooltip>
  );
};
